<template>
  <div>
    <card-toolbar>
      <template #actions>
        <template v-if="bindState">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn id="BindDSPage_unbind" icon v-on="on">
                <v-icon @click="showConfirmModal = true">
                  settings_backup_restore
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $tc("unbind") }}</span>
          </v-tooltip>
        </template>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" id="BindDSPage_reload" @click="reloadp11Info">
              <v-icon outline>
                autorenew
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc("reload") }}</span>
        </v-tooltip>
      </template>
    </card-toolbar>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row no-gutters class="pa-6">
        <v-col cols="12">
          <template v-if="!bindState">
            <v-textarea
              id="BindDSPage_bindString_textField"
              v-model="bindString"
              counter
              auto-grow
              row="1"
              row-height="5"
              :label="$tc('bind_string_label')"
              :error-messages="bindStringErrors"
              @input="$v.bindString.$touch()"
              @blur="$v.bindString.$touch()"
            />

            <v-row no-gutters justify="end" class="mt-2">
              <v-btn
                id="BindDSPage_bind"
                color="blue"
                :disabled="$v.$invalid"
                :dark="!$v.$invalid"
                @click="bind"
              >
                {{ $t("bind_dinamo_services") }}
              </v-btn>
            </v-row>
          </template>
          <template v-else>
            <content-area :items="items" style="background: transparent;" />
          </template>
        </v-col>
      </v-row>
    </v-card>
    <confirm-modal
      id="BindDSPage_removeBind_confirm_modal"
      :open="showConfirmModal"
      :title="$tc('unbind_title')"
      :message="$tc('unbind_warning')"
      @negative="showConfirmModal = false"
      @positive="unbind"
    />
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
import ContentArea from '@/components/ContentArea.vue'
import ConfirmModal from '@/components/ConfirmModal.vue'
import { required } from 'vuelidate/lib/validators'
export default {
  mounted () {
    this.reloadp11Info()
  },
  components: {
    ContentArea,
    ConfirmModal,
    CardToolbar
  },
  data () {
    return {
      bindString: null,
      showConfirmModal: false
    }
  },
  computed: {
    bindState () {
      return this.$store.getters['hsm/GET_P11_INFO_PROP']('ds_bound') === 1
    },
    dsAccount () {
      return this.$store.getters['hsm/GET_P11_INFO_PROP']('ds_account')
    },
    dsHsm () {
      return this.$store.getters['hsm/GET_P11_INFO_PROP']('ds_hsm')
    },
    dsUrl () {
      return this.$store.getters['hsm/GET_P11_INFO_PROP']('ds_url')
    },
    items () {
      return [
        {
          title: this.$tc('ds_account'),
          data: this.dsAccount
        },
        {
          title: this.$tc('dsHsm'),
          data: this.dsHsm
        },
        {
          title: this.$tc('dsUrl'),
          data: this.dsUrl
        }
      ]
    },
    bindStringErrors () {
      const errors = []
      if (!this.$v.bindString.$dirty) return errors
      !this.$v.bindString.validBase64 &&
        errors.push(this.$t('$validation.invalid_bind_token'))
      return errors
    }
  },
  methods: {
    reloadp11Info () {
      this.$store.dispatch('hsm/getP11Info')
    },
    async unbind () {
      await this.callBind('AA==')
      this.showConfirmModal = false
    },
    async bind () {
      await this.callBind(this.bindString)
      this.bindString = null
    },
    callBind (token) {
      const body = { token }
      this.$store.dispatch('hsm/bindDS', { body })
        .then(() => {
          this.$notify.success({})
          this.reloadp11Info()
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    }
  },
  validations () {
    const validations = {}
    const validBase64 = value => {
      if (!value) return true
      const numbeOfMatches = (value.match(/^([A-Za-z0-9]+\/)?[A-Za-z0-9=+/]+$/g))
      if (!numbeOfMatches) return false
      return numbeOfMatches.length === 1
    }
    validations.bindString = {
      required,
      validBase64
    }
    return validations
  }
}
</script>
